import React from 'react'
import TemplateBadge from '../TemplateBadge'
import Item from '../../Layout/Item'

/**
 * Component to render template badges
 */
const TemplateBadges = ({ template, showBadges, isUsingUnifiedConvo, visibleAudienceBadges }) => {
  if (!showBadges) {
    return null
  }

  return (
    <TemplateBadge
      template={template}
      showAudience={true}
      showPreApproval={true}
      isUsingUnifiedConvo={isUsingUnifiedConvo}
      size="small"
      visibleAudienceBadges={visibleAudienceBadges}
    />
  )
}

const TemplateItem = ({
  template,
  onClick,
  isSelected = false,
  showBadges = true,
  isUsingUnifiedConvo,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(template)
    }
  }

  return (
    <Item onClick={handleClick} isSelected={isSelected}>
      <Item.Header
        title={template.name}
        badges={
          <TemplateBadges
            template={template}
            showBadges={showBadges}
            isUsingUnifiedConvo={isUsingUnifiedConvo}
            visibleAudienceBadges={isUsingUnifiedConvo ? null : ['amp_and_appraiser', 'amp_and_lender', 'internal']}
          />
        }
      />

      <Item.Description>
        {template.text}
      </Item.Description>
    </Item>
  )
}

export default TemplateItem
